import {Exclude, Expose} from 'class-transformer';

@Exclude()
export class ShareRefApiModel {
  @Expose() public type: string;
  @Expose() public id: string;
}
